import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const NumberCurrancyField = (props) => {
  const { inputRef, onBlur, name, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onBlur={(evt) => onBlur(evt)}
      decimalScale={2}
      thousandSeparator="."
      decimalSeparator=","
      fixedDecimalScale
      isNumericString
      prefix="R$ "
    />
  );
};

NumberCurrancyField.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
};

export default NumberCurrancyField;
